import React from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';
import { setDataLayer } from 'shared/actions/globals';
import { connect } from 'react-redux';
import API from 'shared/constants/api';
import NOTIFICATION_TYPES from 'shared/actions/notificationTypes';
import { withFetch } from 'shared/hocs/withFetch';
import { EVENTS } from 'shared/constants/gtmEvents';
import {
  getDisplayName,
  getFondyCheckoutUrl,
  iniRedirectToCheckout,
  doRedirectToCheckout,
} from '../helpers/common';
import FondyContainer from '../components/FondyFrame/FondyContainer';
import FondyInvoiceContainer from '../components/FondyFrame/FondyInvoiceContainer';
import Modal from '../components/Modal/Modal';

import { toLocalized } from '../helpers/locale';
import { ORDER_STATUSES, PAYMENT_METHODS, URLS, PACKAGES } from '../constants/payment';
import { enqueueNotification } from '../actions/notifications';
import history from '../../history';

const throwIfResponseNotOkay = () => response => {
  if (!response.ok) {
    throw new Error('Произошла ошибка');
  }

  return response;
};

// const doRedirectToCheckout = url => {
//   if (
//     typeof window.fondyP24Window === 'undefined' ||
//     !window.fondyP24Window ||
//     window.fondyP24Window.closed ||
//     typeof window.fondyP24Window.closed === 'undefined'
//   ) {
//     // if pop-up is blocked
//     return window.location.replace(url);
//   }
//   window.fondyP24Window.location = url;
//   return window.fondyP24Window.location;
// };

const getFondyOrderData = (fetch, token, data) =>
  fetch(API.PAYMENT.FONDY_ORDER_CHECKOUT, {
    method: 'POST',
    headers: {
      Authorization: `JWT ${token}`,
    },
    body: JSON.stringify(data),
  });

const getMonoOrderData = (fetch, token, data) =>
  fetch(API.PAYMENT.MONO_ORDER_CHECKOUT, {
    method: 'POST',
    headers: {
      Authorization: `JWT ${token}`,
    },
    body: JSON.stringify(data),
  });

const updateAdvertParams = (advertParams, fetch, token, advertID, promoteInSocial) => {
  if (advertParams.kind && advertParams.kind === PACKAGES.C2C_TURBO && promoteInSocial) {
    fetch(API.ADVERT.ITEM(advertID), {
      method: 'PATCH',
      headers: {
        Authorization: `JWT ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ promote_in_social: promoteInSocial }),
    });
  }
};

const withOrders = WrappedComponent => {
  const Component = class extends React.Component {
    static displayName = `withOrders(${getDisplayName(WrappedComponent)})`;

    static propTypes = {
      promoteInSocial: PropTypes.number.isRequired,
      setDataLayer: PropTypes.func.isRequired,
      fetch: PropTypes.func.isRequired,
      intl: intlShape.isRequired,
      enqueueNotification: PropTypes.func.isRequired,
      user: PropTypes.shape().isRequired,
    };

    state = {
      fondyFrameUrl: '',
      fondyCb: null,
      showModal: false,
      showInvoiceModal: false,
      billAmount: null,
      accountNumber: null,
      eventCounter: 1,
    };

    setGtmEvent = gtmId => {
      if (!gtmId) return;

      const { eventCounter } = this.state;
      const dataLayer = window && Array.isArray(window.dataLayer) && window.dataLayer;
      const gtmDataLayerValue = dataLayer && dataLayer.find(el => el.event === gtmId.event);

      if (gtmDataLayerValue) {
        const newCounter = eventCounter + 1;
        this.setState({ eventCounter: newCounter });
        this.props.setDataLayer({
          ...gtmId,
          event: `${gtmId.event}${newCounter}/`,
        });
      } else {
        this.props.setDataLayer(gtmId);
      }
    };

    getGtmEvent = gtmType => {
      const { user } = this.props;
      const isBusiness = user.user.tariff && user.user.tariff.is_business;
      const isDealership = user.user.tariff && user.user.tariff.slug === 'b2c-plus';

      if (isDealership) {
        return EVENTS.advert.dealership[gtmType];
      } else if (isBusiness) {
        return EVENTS.advert.business[gtmType];
      }
      return EVENTS.advert[gtmType];
    };

    sendGtmMetrics = params => {
      if (params.kind === 'subscription') this.setGtmEvent(this.getGtmEvent(params.details.tariff));
      else if (params.kind === 'c2c-free' && params.details && params.details.promos) {
        params.details.promos.map(item => {
          this.setGtmEvent(this.getGtmEvent(item));
        });
      } else this.setGtmEvent(this.getGtmEvent(params.kind));
    };

    closeModal = () => {
      this.setState({ showModal: false, showInvoiceModal: false });
    };

    handleChangeInvoiceData = (amount, account) => {
      this.setState({
        billAmount: amount,
        accountNumber: account,
        showInvoiceModal: true,
      });
    };

    handleChangeUrl = (url, cb) => {
      this.setState({ fondyFrameUrl: url, showModal: true, fondyCb: cb });
    };

    postOrderAndProceedToPayment = (token, params, redirectUrl, paymentMethod, cb) => {
      const { fetch, intl, promoteInSocial } = this.props;
      const { locale } = intl;
      const redirectUrlLocalized = toLocalized(redirectUrl, locale);
      const advertId = params.details && params.details.advert_id;
      iniRedirectToCheckout();
      return (() =>
        // if (
        //   paymentMethod === PAYMENT_METHODS.FONDY_P24 ||
        //   paymentMethod === PAYMENT_METHODS.INVOICE
        // ) {
        //   // Create window before xhr(fecth) async request
        //   window.fondyP24Window = window.open('', '_blank');
        // }
        fetch(API.PAYMENT.orders(), {
          method: 'POST',
          headers: {
            Authorization: `JWT ${token}`,
          },
          body: JSON.stringify(params),
        })
          .then(throwIfResponseNotOkay())
          .then(r => r.json())
          .then(({ number, status }) => {
            if (status === ORDER_STATUSES.PAID || paymentMethod === PAYMENT_METHODS.BALANCE) {
              this.sendGtmMetrics(params);
              this.props.setDataLayer(EVENTS.paidAdSent);
              this.props.enqueueNotification({
                text: intl.formatMessage({ id: 'Оплата прошла успешно' }),
                type: NOTIFICATION_TYPES.SUCCESS,
              });
              updateAdvertParams(params, fetch, token, advertId, promoteInSocial);
              if (cb) cb({ number, status });
              else history.push(redirectUrlLocalized);
            } else {
              const handlerUrl = `${URLS.HANDLER_URL_FULL}?redirectUrl=${redirectUrlLocalized}`;

              switch (paymentMethod) {
                case PAYMENT_METHODS.INVOICE: {
                  return getFondyOrderData(fetch, token, {
                    order_number: number,
                    response_url: handlerUrl,
                    lang: locale,
                  })
                    .then(throwIfResponseNotOkay())
                    .then(r => r.json())
                    .then(data => {
                      this.sendGtmMetrics(params);
                      this.props.setDataLayer(EVENTS.paidAdSent);
                      const url = getFondyCheckoutUrl(data, false, true);
                      updateAdvertParams(params, fetch, token, advertId, promoteInSocial);
                      doRedirectToCheckout(url);
                    });
                }
                case PAYMENT_METHODS.MONO: {
                  return getMonoOrderData(fetch, token, {
                    order_number: number,
                    response_url: handlerUrl,
                    lang: locale,
                  })
                    .then(throwIfResponseNotOkay())
                    .then(r => r.json())
                    .then(data => {
                      this.sendGtmMetrics(params);
                      this.props.setDataLayer(EVENTS.paidAdSent);
                      const url = data.checkout_url;
                      updateAdvertParams(params, fetch, token, advertId, promoteInSocial);
                      doRedirectToCheckout(url);
                    });
                }
                default:
                  break;
              }
            }

            return Promise.resolve();
          }))().catch(e => {
        this.props.enqueueNotification(intl.formatMessage({ id: e.message ? e.message : e }));
        if (cb) cb(null, e.message ? e.message : e);
      });
    };

    renderPaymentModal = () =>
      <Modal>
        <FondyContainer
          closeHandler={this.closeModal}
          frameUrl={this.state.fondyFrameUrl}
          callback={this.state.fondyCb}
        />
      </Modal>;
    renderInvoiceModal = (billAmount, accountNumber) =>
      <Modal>
        <FondyInvoiceContainer
          closeHandler={this.closeModal}
          billAmount={billAmount}
          accountNumber={accountNumber}
        />
      </Modal>;
    render() {
      return (
        <div>
          <WrappedComponent
            {...this.props}
            postOrderAndProceedToPayment={this.postOrderAndProceedToPayment}
          />
          {this.state.showModal && this.renderPaymentModal()}
          {this.state.showInvoiceModal &&
            this.renderInvoiceModal(this.state.billAmount, this.state.accountNumber)}
        </div>
      );
    }
  };

  const mapDispatchToProps = {
    enqueueNotification,
    setDataLayer,
  };

  const mapStateToProps = ({ globals, user }) => ({
    promoteInSocial: globals.promoteInSocial,
    user,
  });

  return connect(mapStateToProps, mapDispatchToProps)(injectIntl(withFetch(Component)));
};

export default withOrders;



// WEBPACK FOOTER //
// ./src/shared/hocs/withOrders.js